//for action and buttons both
export default {
    'System Settings':{
        bn:'সিস্টেম সেটিংস'
    },
    'Modules & Tasks':{
        bn:'মডিউল ও টাস্ক'
    },
    'System Configuration':{
        bn:'সিস্টেম কনফিগারেশন'
    },
    'User Groups':{
        bn:'ব্যবহারকারীর গ্রুপ'
    },
    'User Types':{
        bn:'ব্যবহারকারীর টাইপ'
    },
    'Setup':{
        bn:'সেটআপ'
    },
    'Admin Setup':{
        bn:'অ্যাডমিন সেটআপ'
    },
    'Designations':{
        bn:'পদবীসমুহ'
    },
    'Principals':{
        bn:'প্রিন্সিপালস'
    },
    'Competitors':{
        bn:'কম্পেটিটরস'
    },
    'Seasons':{
        bn:'ঋতুসমূহ'
    },
    'Users':{
        bn:'ব্যাবহারকারীরা'
    },
    'Crop Classification':{
        bn:'ফসল সেটিংস'
    },
    'Crop':{
        bn:'ফসল'
    },
    'Crop Types':{
        bn:'ফসলের প্রকারভেদ'
    },
    'Variety':{
        bn:'ভ্যারাইটি'
    },
}
